module.exports = __webpack_public_path__ + "img/1728634650110-Screenshot 33.png.f42e5dcd.webp";